import API from './client'

export interface OfferView {
  _id: string
  livreur: { name: string; rating: number; vehicle?: string; distanceKm?: number }
  proposedPickupAt: string
  note?: string
  status: 'pending' | 'selected' | 'rejected' | 'withdrawn' | 'expired'
  isFastest: boolean
}

export const offersAPI = {
  // Diffuser le colis aux livreurs de sa région
  broadcast: async (id: string): Promise<{ region: string; notified: number }> => {
    const res = await API.post(`/deliveries/${id}/broadcast`)
    return res.data
  },

  // Offres reçues, triées (plus rapide en tête)
  getOffers: async (id: string): Promise<OfferView[]> => {
    const res = await API.get(`/deliveries/${id}/offers`)
    return res.data.offers
  },

  // Sélection manuelle d'une offre
  select: async (id: string, offerId: string) => {
    const res = await API.post(`/deliveries/${id}/offers/${offerId}/select`)
    return res.data.delivery
  },

  // Sélection automatique du plus rapide
  autoSelect: async (id: string) => {
    const res = await API.post(`/deliveries/${id}/offers/auto-select`)
    return res.data.delivery
  },
}
